var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('div',{staticClass:"search__icon"},[_c('dd-icon',{attrs:{"name":"search","scale":"0.7"}})],1),_c('input',{staticClass:"search__input",attrs:{"type":"text","placeholder":"Buscador"}})])}
var staticRenderFns = []

export { render, staticRenderFns }